export const formatPoint = (getValue) => {
    if (getValue !== undefined && getValue !== null) {
        const pointFormat = getValue
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        return pointFormat;
    }
    return '0';
};

export default { formatPoint };
